import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';

import LabelAndInputDate from '../common/form/labelAndInputDate';

import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import { setError } from '../common/toast/toast';

import {
	setModoTela, initForm, baixarImagem, salvar, salvarConferido
} from './conferenciaChecklistActions';

class ConferenciaChecklistForm extends Component {

	state = {

	}

	componentWillMount() {
		let initSeletorImagemChecklist = () => {
			const fileSelectorImagemChecklist = document.createElement('input');
			fileSelectorImagemChecklist.setAttribute('type', 'file');
			fileSelectorImagemChecklist.addEventListener("change", (data) => {

				let reader = new FileReader();
				let file = data && data.path && data.path[0] && data.path[0].files && data.path[0].files[0] ? data.path[0].files[0] : null;
				if (!file) {
					file = data && data.target && data.target.files && data.target.files[0] ? data.target.files[0] : null;
				}

				if (file) {

					if (!file.type.includes('image/png') && !file.type.includes('image/jpg') && !file.type.includes('image/jpeg')) {
						setError('Selecione apenas (.PNG, .JPG e .JPEG)');

						this.setState({
							checklistRespostsEdicao: null
						});

						return;
					}

					reader.onloadend = () => {

						const editado = {
							...this.state.checklistRespostaEdicao,
							respostas: this.state.checklistRespostaEdicao.respostas.map(item => {
								if (item.editando) {
									return {
										...item,
										imagem1: item.imagemEditando == 1 ? reader.result : item.imagem1,
										imagem2: item.imagemEditando == 2 ? reader.result : item.imagem2,
										imagem3: item.imagemEditando == 3 ? reader.result : item.imagem3,
										imagem4: item.imagemEditando == 4 ? reader.result : item.imagem4,
										imagem5: item.imagemEditando == 5 ? reader.result : item.imagem5,
										editando: null,
										imagemEditando: null
									};
								}

								return {
									...item
								};
							})
						};

						this.props.salvar(editado);

						this.setState({
							checklistRespostsEdicao: null
						});

						initSeletorImagemChecklist();

					}

					reader.readAsDataURL(file);

				} else {
					this.setState({
						checklistRespostsEdicao: null
					});
				}
			});

			this.fileSelectorImagemChecklist = fileSelectorImagemChecklist;
		};

		initSeletorImagemChecklist();
	}

	render() {

		let readOnly = this.props.excluir ? 'readOnly' : '';

		const checklistResposta = this.props.formularioValues;	

		return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						<Table responsive striped style={{ maxHeight: '100%' }}>
							<THead>
								<Tr>
									<Th>Pergunta</Th>
									<Th alignCenter>Conformidade</Th>
									<Th>Observação</Th>
									<Th alignCenter>Foto</Th>
								</Tr>
							</THead>
							<TBody>
								
								{checklistResposta.foto_carga &&
								<Tr>
									<Td>FOTO DA CARGA COMPLETA</Td>
									<Td alignCenter></Td>
									<Td></Td>
									<Td alignCenter>
										<div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
											<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
												<img
													src={checklistResposta.foto_carga.replace('data:JPEG', 'data:image/jpeg')}
													style={{ height: 400 }}
												/>
											</div>
										</div>
									</Td>
								</Tr>}

								{(JSON.parse(checklistResposta.respostas) || []).map((item, i) => {

									return (
										<Tr key={item.id_pergunta} >
											<Td>{item.pergunta}</Td>
											<Td alignCenter>{item.conformidade == null ? '' : (item.conformidade ? 'SIM' : 'NÃO')}</Td>
											<Td>{item.observacao}</Td>
											<Td alignCenter>

												<div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>

													{[1, 2, 3, 4, 5].map((num) => {
														const imagem = item[`imagem${num}`];

														if (!imagem && num == 1) {
															return (
																<div key={num} style={{ display: 'flex', gap: 10, marginTop: 5, justifyContent: 'center' }}>
																	<button
																		type="button"
																		className="btn btn-flat btn-outline-secondary"
																		onClick={() => {

																			this.setState({
																				checklistRespostaEdicao: {
																					...checklistResposta,
																					respostas: (JSON.parse(checklistResposta.respostas) || []).map(itemAux => {
																						if (itemAux.id_pergunta == item.id_pergunta) {
																							return {
																								...itemAux,
																								editando: true,
																								imagemEditando: num
																							}
																						}

																						return {
																							...itemAux
																						};
																					})
																				}
																			});

																			this.fileSelectorImagemChecklist.click();
																		}}
																	>
																		<i className="fas fa-camera"></i> Adicionar
																	</button>
																</div>
															)
														} else if (!imagem) {
															return null;
														}

														const img = imagem.replace('data:JPEG', 'data:image/jpeg');

														return (
															<div key={num} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>

																<img
																	src={img}
																	style={{ height: 400 }}
																/>

																<div style={{ display: 'flex', gap: 10, marginTop: 5 }}>

																	{/* BOTÃO DOWNLOAD */}
																	<button
																		type="button"
																		className="btn btn-flat btn-outline-primary"
																		onClick={() =>
																			this.props.baixarImagem(img, `foto_${num}`)
																		}
																	>
																		<i className="fas fa-download"></i> Baixar
																	</button>

																	{/* BOTÃO EDITAR */}
																	<button
																		type="button"
																		className="btn btn-flat btn-outline-secondary"
																		onClick={() => {

																			this.setState({
																				checklistRespostaEdicao: {
																					...checklistResposta,
																					respostas: (JSON.parse(checklistResposta.respostas) || []).map(itemAux => {
																						if (itemAux.id_pergunta == item.id_pergunta) {
																							return {
																								...itemAux,
																								editando: true,
																								imagemEditando: num
																							}
																						}

																						return {
																							...itemAux
																						};
																					})
																				}
																			});

																			this.fileSelectorImagemChecklist.click();
																		}}
																	>
																		<i className="fas fa-edit"></i> Editar
																	</button>

																</div>

															</div>
														);
													})}

												</div>
											</Td>
										</Tr>
									)
								})}
							</TBody>
						</Table>

						{checklistResposta &&
						<Row>
							<LabelAndInput
								label='Observação da Conferência' placeholder='Informe a observação'
								cols='12 12 12 12'
								readOnly={checklistResposta.conferido ? 'readOnly' : null}
								value={this.state.observacao_conferencia != null ? this.state.observacao_conferencia : checklistResposta.observacao_conferencia}
								onChange={data => {
									this.setState({
										observacao_conferencia: data.target.value
									});
								}} />
						</Row>}
					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								<Button
									text={checklistResposta.conferido ? 'Não Conferido' : 'Conferido'}
									type={checklistResposta.conferido ? 'danger' : 'success'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.salvarConferido({
										...checklistResposta, 
										observacao_conferencia: this.state.observacao_conferencia != null ? this.state.observacao_conferencia : checklistResposta.observacao_conferencia
									})} />
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.setModoTela('lista')} />
							</Grid>
						</Row>
					</ContentCardFooter>
				</Form>
			</ContentCard>
		)
	}


}

ConferenciaChecklistForm = reduxForm({ form: 'conferenciaChecklistForm', destroyOnUnmount: false })(ConferenciaChecklistForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioLogado: state.auth.usuarioLogado,
	formularioValues: getFormValues('conferenciaChecklistForm')(state),
	registro: state.conferenciaChecklist.registro,
	listaMotorista: state.conferenciaChecklist.listaMotorista,
	listaForma: state.conferenciaChecklist.listaForma,
	listaCidade: state.conferenciaChecklist.listaCidade,
	listaContaBancaria: state.conferenciaChecklist.listaContaBancaria
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm, salvar, baixarImagem, salvarConferido
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(ConferenciaChecklistForm);
